import { closeModal, ModalType } from 'app/reducers/modalSlice';
import { useAppDispatch, useAppSelector } from 'app/store/hook';
import React, { CSSProperties, MouseEvent } from 'react';
import { createPortal } from "react-dom";

export default function AppModalContainer() {
  const dispatch = useAppDispatch();
  const allModals = useAppSelector((state) => state.modal.modals);

  const handleClickClose = (event: MouseEvent) => {
    event.preventDefault();
    dispatch(closeModal());
  }

  const renderModal = allModals?.map((modal: ModalType, modalIndex: number) => {
    const backgroundStyle: CSSProperties | undefined = (allModals.length - 1) === modalIndex ? undefined : { background: 'rgba(0,0,0,0)' };
    const ModalComponent = modal.target;
    const activeProps = modal.confirmProps ? modal.confirmProps : modal.modalProps;

    let layerWrapClass: string = 'layer-wrap';
    if (modal.wrapClass) {
      layerWrapClass += ` ${modal.wrapClass}`;
    }

    return (
      <div key={modal.path} className="layer-bg fade in" style={backgroundStyle}>
        <div className={layerWrapClass} style={modal.wrapStyle}>
          <ModalComponent {...activeProps} />
          {(modal.modalProps && !modal.confirmProps) && (
            <a className="btn-close-layer" onClick={(e) => handleClickClose(e)}>
              <i className="xi-close" aria-hidden="true"></i>
              <span className="hid">닫기</span>
            </a>
          )}
        </div>
      </div>
    );
  });

  const modalRoot = document.getElementById('modal') as HTMLElement;
  return createPortal(<>{renderModal}</>, modalRoot);
}